import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Box, List, ListItem } from "@mui/material";

const useStyles = makeStyles(theme => ({
  item: {
    border: "1px solid #D3D3D3",
    borderRadius: "5px",
    marginBottom: 3
  }
}));

const PrerequisiteTooltipContent = props => {
  const classes = useStyles();
  const { prerequisites } = props;
  console.log("in a TooltipContent: ", prerequisites);

  const prerequisitesList = prerequisites.map((prerequisite, index) => {
    return (
      <ListItem className={classes.item} key={prerequisite}>
        <Typography key={index} variant="subtitle2" color="textSecondary">
          {prerequisite}
        </Typography>
      </ListItem>
    );
  });

  return (
    <Box>
      <Typography variant="h6" color="textPrimary">
        Prerequisites:
      </Typography>
      <List>{prerequisitesList}</List>
    </Box>
  );
};

export default PrerequisiteTooltipContent;
